import { ofetch } from 'ofetch'
import { config } from '@/config.settings'
import { apiMethods, parseApiResponse } from '@/contexts/shared/api/constructor/ApiFetcherConstructor.helpers'
import { redirectIfUnauthorized } from '@/contexts/shared/api/constructor/ApiFetcherConstructor.composables'

const apiFetch = ofetch.create({
  baseURL: config.base_url,
  credentials: 'include',
  ignoreResponseError: true,
  onRequestError() {
    document.location.href = '/'
  },
})

export interface UseApiErrorData {
  ok: false
  message: string
}

const apiFetcher = <T, E>(url: string, options = {}) =>
  apiFetch
    .raw<T>(url, options)
    .then(parseApiResponse<T, E>)
    .then(redirectIfUnauthorized<T, E>)

export const useApi = apiMethods<UseApiErrorData>(apiFetcher)
